import { Outlet } from "react-router-dom";
import { ProtectedRoute, AppHeader } from "@components";

export default function ProtectedLayout({ roles = [1, 2, 3] }) {
  return (
    <ProtectedRoute allowedRoles={roles}>
      <AppHeader />
      <Outlet />
    </ProtectedRoute>
  );
}
